module.exports = __webpack_public_path__ + "img/06.408f97f4.jpg";